import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app-service.service';
import { ForumQuestionComponent } from '../forum-question/forum-question.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forums',
  templateUrl: './forums.component.html',
  styleUrls: ['./forums.component.scss']
})
export class ForumsComponent implements OnInit {

  forums: any = [];
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  paginatedForums: any = [];
  
  constructor(private appService: AppService, private dialog: MatDialog, private router:Router) { }

  ngOnInit(): void {
    this.loadForums();
  }

  loadForums() {
    this.appService.getForums().subscribe((res: any) => {
      this.forums = res.sort((a: any, b: any) => {
        const dateCompare = new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        if (dateCompare === 0) {
          return a.title.localeCompare(b.title);
        }
        return dateCompare;
      });
      this.forums.forEach((forum: any) => {
        forum.createdAt = new Date(forum.createdAt);
      });
      
      this.totalItems = this.forums.length;
      this.updatePaginatedForums();
    })
  }

  updatePaginatedForums() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = Math.min(startIndex + this.pageSize, this.totalItems);
    this.paginatedForums = this.forums.slice(startIndex, endIndex);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.updatePaginatedForums();
  }

  addQuestion() {
    let dialogRef = this.dialog.open(ForumQuestionComponent, {
      width: '80%',
      height: '550px'
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.loadForums();
      }
    })
  }

  openDetails(forum:any) {
    this.router.navigateByUrl(`/forums/${forum.id}`);
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  get pages(): number[] {
    const pageCount = this.totalPages;
    const pages = [];
    
    // Show at most 5 page numbers
    const maxPagesToShow = 5;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(pageCount, startPage + maxPagesToShow - 1);
    
    // Adjust if we're near the end
    if (endPage - startPage + 1 < maxPagesToShow && startPage > 1) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  }
}
